import { Component, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/system/admin/pages/catalogs/services/permissions.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public model: any[] = [];

  constructor(private permissionsService: PermissionsService) {}
  ngOnInit() {
    const itemsMenu = [
      {
        label: 'Panel de control',
        icon: 'pi pi-home',
        items: [
          {
            label: 'Dashboard',
            permissionKey: 'dashboard',
            icon: 'pi pi-chart-bar',
            routerLink: ['/']
          },
          {
            label: 'Academia',
            permissionKey: 'academy',
            icon: 'fa fa-graduation-cap',
            routerLink: ['/academy']
          },
          {
            label: 'Instancias',
            permissionKey: 'instance',
            icon: 'pi pi-building',
            routerLink: ['/companies']
          },
        ]
      },
      {
        label: 'Administración',
        permissionKey: '',
        icon: 'pi pi-money-bill',
        items: [
          { label: 'Recursos Humanos',
            permissionKey: 'humanResource',
            icon: 'fa-solid fa-users-rays',
            items: [
              {
                label: 'Empleados',
                permissionKey: '',
                icon: 'fa-solid fa-users',
                routerLink: ['/employee']
              }
            ]
          },
          {
            label: 'Cotizaciones',
            permissionKey: 'quote',
            icon: 'fa fa-money',
            routerLink: ['/quotes']
          },
          {
            label: 'Clientes',
            permissionKey: 'customer',
            icon: 'fa fa-users',
            routerLink: ['/quotes/customers']
          },
          {
            label: 'Atención Pestforce',
            permissionKey: 'pestforce',
            icon: 'fa fa-ticket',
            routerLink: ['/tickets']
          },
          {
            label: 'Notificaciones',
            permissionKey: 'notification',
            icon: 'fa fa-bell',
            routerLink: ['/notifications']
          },
        ]
      },
      {
        label: 'Catálogos del sistema',
        permissionKey: '',
        icon: 'pi pi-briefcase',
        items: [
          {
            label: 'Catálogos',
            permissionKey: '',
            icon: 'fa fa-list',
            items: [
              {
                label: 'Países',
                permissionKey: 'country',
                icon: 'pi pi-globe',
                routerLink: ['/country']
              },
              {
                label: 'Tipo de servicio',
                permissionKey: 'serviceType',
                icon: 'fa-address-book fa-solid',
                routerLink: ['/quotes/service-type']
              },
              {
                label: 'Fuente de origen',
                permissionKey: 'originSource',
                icon: 'fa fa-file-invoice',
                routerLink: ['/quotes/origin-source']
              },
              {
                label: 'Impuestos',
                permissionKey: 'tax',
                icon: 'fas fa-money-check-alt',
                routerLink: ['/quotes/tax']
              },
              {
                label: 'Descuentos',
                permissionKey: 'discount',
                icon: 'fa fa-percent',
                routerLink: ['/quotes/discount']
              },
              {
                label: 'Motivos de cancelación',
                permissionKey: 'cancelReason',
                icon: 'fa-ban fa-solid',
                routerLink: ['/quotes/rejection-reasons']
              },
              {
                label: 'Recursos Humanos',
                permissionKey: 'humanResourceCatalog',
                icon: 'pi pi-users',
                routerLink: ['/human-resources']
              },
            ]
          },
        ]
      }
    ];

    this.permissionsService.ready$
      .subscribe(ready => {
        if (ready) {
          this.model = this.filterMenuByPermission(itemsMenu);
        }
      });
  }

  private filterMenuByPermission(items: any[]): any[] {
    return items
      .filter(item => {
        if (!item.permissionKey) return true;

        return this.permissionsService.hasPermission(item.permissionKey);
      })
      .map(item => {
        const newItem = { ...item };

        if (newItem.items) {
          newItem.items = this.filterMenuByPermission(newItem.items);

          if (newItem.items.length === 0 && !newItem.routerLink) {
            return null;
          }
        }

        return newItem;
      })
      .filter(item => item !== null);
  }
}
